// Language selector
import "./LangSwitch.css";
import { useTranslation } from "react-i18next";
import { availableLanguages } from "../../../i18n";
import Cookies from "universal-cookie";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useEffect, useState } from "react";
import api from "../../../api/resources";
import authAPI from "../../../api/authentication";

export default function LangSwitch() {
  const { i18n } = useTranslation();
  const [langCode, setLangCode] = useState(i18n.resolvedLanguage);
  const [langInit, setLangInit] = useState(false);

  // Get language preference from back end on mount
  useEffect(() => {
    const getUserLanguage = async () => {
      const userData = await authAPI.getUserInfo();
      if (userData?.user?.language) {
        i18n.changeLanguage(userData.user.language);
        setLangCode(userData.user.language);
      }
      setLangInit(true);
    };

    getUserLanguage();
  }, [i18n]);

  const handleChange = async (event, newLangCode) => {
    if (newLangCode && newLangCode !== langCode) {
      setLangCode(newLangCode);
      await api.updateUser({ language: newLangCode });
    }
  };

  useEffect(() => {
    if (langInit) {
      i18n.changeLanguage(langCode);
      const cookies = new Cookies();
      cookies.set("language", langCode, { path: "/" });
    }
  }, [langCode, i18n, langInit]);

  return (
    <ToggleButtonGroup
      className="LangSwitch"
      value={langCode}
      size={"small"}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
    >
      {Object.keys(availableLanguages).map((code, index) => (
        <ToggleButton key={index} value={code}>
          {code}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
